export const SalesIconV2 = ({ width = 46 }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 67 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="0.5" width="65" height="65" rx="32.5" fill="white" />
      <rect x="1" y="0.5" width="65" height="65" rx="32.5" stroke="#916CF1" />
      <path
        d="M29.7484 48.2728C30.8832 48.2728 31.803 47.3529 31.803 46.2182C31.803 45.0834 30.8832 44.1636 29.7484 44.1636C28.6137 44.1636 27.6938 45.0834 27.6938 46.2182C27.6938 47.3529 28.6137 48.2728 29.7484 48.2728Z"
        fill="#19AE57"
        stroke="#15112D"
        strokeWidth="0.326018"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.2118 48.2728C44.3465 48.2728 45.2664 47.3529 45.2664 46.2182C45.2664 45.0834 44.3465 44.1636 43.2118 44.1636C42.0771 44.1636 41.1572 45.0834 41.1572 46.2182C41.1572 47.3529 42.0771 48.2728 43.2118 48.2728Z"
        fill="#FD561F"
        stroke="#15112D"
        strokeWidth="0.326018"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.4799 48.2728C37.6146 48.2728 38.5345 47.3529 38.5345 46.2182C38.5345 45.0834 37.6146 44.1636 36.4799 44.1636C35.3452 44.1636 34.4253 45.0834 34.4253 46.2182C34.4253 47.3529 35.3452 48.2728 36.4799 48.2728Z"
        fill="#F7AD3C"
        stroke="#15112D"
        strokeWidth="0.326018"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5303 17.7271H22.4697C22.4697 17.7271 23.1704 20.8298 23.6194 22.818C24.5166 26.7905 25.7488 32.2467 26.4717 35.4477C26.8212 36.995 28.1952 38.0907 29.7816 38.0907H44.3533C45.944 38.0907 47.3213 36.9858 47.6663 35.4331L50.4697 22.818"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.4695 22.8179H24.1665"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
